import { HubConnectionBuilder } from '@microsoft/signalr';
import { SystemTaskResponseDTO } from 'business/models/Models';
import { JobTypeDTO } from 'components/main/Setup/Imaging/ImageManagementTask/constants';
import store from 'redux/configureStore';
import { updateProgress } from 'redux/reducers/systemTaskReducer';

const HIT_COUNT_JOB_TYPE = JobTypeDTO.HitCountRecalculation;

type ProgressJob = { jobType?: number; progress?: number };

export async function waitForHitCountRecalculation(
  _args: unknown[],
  taskId: number,
): Promise<SystemTaskResponseDTO> {
  const response = new SystemTaskResponseDTO();
  const connection = new HubConnectionBuilder().withUrl('/progressHub').build();

  return new Promise((resolve) => {
    let finished = false;

    const complete = (success: boolean, message = '') => {
      if (finished) {
        return;
      }
      finished = true;
      clearTimeout(noJobTimeout);
      connection.stop();
      response.success = success;
      response.message = message;
      resolve(response);
    };

    const onJob = (data: ProgressJob) => {
      if (data?.jobType !== HIT_COUNT_JOB_TYPE || data.progress == null) {
        return;
      }
      clearTimeout(noJobTimeout);
      store.dispatch(updateProgress({ taskId, progress: data.progress }));
      if (data.progress >= 100) {
        complete(true);
      }
    };

    const noJobTimeout = setTimeout(() => complete(true), 3000);

    connection.on('UpdateJobProgress', onJob);
    connection.on('AddNewJob', onJob);
    connection.on('ReceiveJobsByType', (jobs: ProgressJob[]) => jobs?.forEach(onJob));

    connection
      .start()
      .then(() => connection.invoke('RequestJobsByType', HIT_COUNT_JOB_TYPE))
      .catch(() => complete(false, 'Failed to track hit count recalculation.'));
  });
}
